const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      // Custom code for product page goes here
      if(document.querySelectorAll('.product-thumb--image').length > 0) {
        document.querySelectorAll('.product-thumb--image').forEach(function(target) {
            target.addEventListener('click', (event) => {
                event.preventDefault();
                setTimeout(function() {
                    document.querySelectorAll('.product-thumb--image').forEach(function(targetT) {
                        targetT.classList.remove('swiper-slide-thumb-active');
                    });
                    target.classList.add('swiper-slide-thumb-active');
                }, 200);
                var swiper = new Swiper('.product-carousel');
                swiper?.slideTo(event.target.closest('.product-thumb--image')?.getAttribute('data-index'));
            });
        });
      }

      document.querySelectorAll('custom-accordion').forEach((ele)=>{
        ele.querySelector('.accordion__container:not(.d-none) .accordion__toggle').click();
      })
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
